<template>
    <div class="main">
        <div class="content">
            <div class="content_view">
                <div class="content_text">
                    <div class="content_text-header">
                        <span>备注说明</span>
                        <!-- <span>*</span> -->
                    </div>
                    <div class="content_text-center">
                         <textarea v-model="remack" placeholder="请在这里补充备注说明">
                         </textarea>
                         <!-- <cell-group>
                            <van-field
                                v-model="remack"
                                rows="3"
                                autosize
                                type="textarea"
                                maxlength="100"
                                placeholder="请在这里补充备注说明"
                                show-word-limit
                            />
                        </cell-group> -->
                    </div>
                </div>
                <div class="content_text">
                    <upload :imgUrl="imgUrl" :fileSource='1' :fileBizType='6'></upload>
                </div>
            </div>
            <div class="content_bottom">
                <div class="content_btn" @click="submitBtn">提交</div>
            </div>
        </div>
    </div>
</template>
<script>
    import Upload from '../../components/Upload'
    import api from '../../../../service/modules/integrity'
    export default {
        components: {
            Upload
        },
        data () {
            return {
                remack: '', // 备注
                enterpriseId: this.$route.query.enterpriseId, // 企业ID
                supervisionId: this.$route.query.supervisionId, // 企业监管ID
                imgUrl: [] // 附件上传
            }
        },
        created () {
        },
        mounted () {
            this.$on('fileUploadData', val => {
                this.imgUrl = val
            })
        },
        methods: {
            submitBtn () {
                if (this.remack === '' || !this.remack) {
                    this.remack += '.'
                    this.remack = ''
                    this.$Toast({
                        duration: 2000,
                        message: '请正确填写资料',
                        forbidClick: true
                    })
                } else {
                    let attachs = [...this.imgUrl];
                    if (attachs) {
                        attachs.map(item => { delete item.url })
                    }
                    let data = {
                        mark: this.remack,
                        attach: JSON.stringify(attachs),
                        supervisionId: this.supervisionId // 企业监管ID
                    }
                    api.addRectifyLog(data).then(res => {
                        if (res.ret === 0) {
                            this.$Toast.success({ message: '上传成功', duration: 2000 })
                            this.$router.back({ path: 'supervisionDetails', query: { enterpriseId: this.enterpriseId, supervisionId: this.supervisionId, name: 'uploadFile' } });
                        }
                    })
                }
            }
        }
    }
</script>
<style lang="less" scoped>
.main {
    background: #eee;
    width: 100%;
    height: 100%;
    .content {
        background: #fff;
        height: 100%;
        .content_view {
            .content_text {
                padding: 16px 12px 0 12px;
                .content_text-header {
                    // padding: 16px 0;
                    span:nth-child(1) {
                        font-size: 14px;
                        color:#333;
                    }
                    span:nth-child(2) {
                        color: red;
                    }
                }
                .content_text-center {
                    width: 100%;
                    padding-top:12px;
                    textarea {
                        width: 100%;
                        height: 180px;
                        background-color:#F9F9F9;
                        border:0;
                        outline: none;
                        border-radius: 3px;
                        padding:16px;
                        box-sizing: border-box;
                        font-size: 14px;
                    }
                }
                .content_text-up {
                    padding: 16px 0;
                }
            }
        }
        .content_bottom {
            width: 100%;
            height: 50px;
            background: #fff;
            position: fixed;
            bottom: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            .content_btn {
                background: #36B374;
                color: #fff;
                font-size: 16px;
                height: 40px;
                width: 93%;
                border-radius: 3px;
                text-align: center;
                line-height: 40px;
            }
        }
    }
}
</style>
